import React, { useEffect, useState } from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";

interface SummarySectionProps {
  isEditable: boolean;
  selectedAssesmentData:any
  summaryDat:any
}

const SummarySection: React.FC<SummarySectionProps> = ({ isEditable,selectedAssesmentData,summaryDat }) => {
  const [formData, setFormData] = useState({
    currentTier: selectedAssesmentData.tier_name || 'Registered',
    totalPoints: selectedAssesmentData.total_partner_points || 0,
  });

  const summaryData = [
    {
      icon: "award",
      label: "Current Tier",
      value: formData.currentTier,
      field: "currentTier",
      color: "green",
    },
    {
      icon: "arrowTrendUp",
      label: "Total Points",
      value: formData.totalPoints,
      field: "totalPoints",
      color: "orange",
    },
  ];





  const handleInputChange = (field: string, value: string | number) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="detail-section">
      <h2>Summary</h2>
      <div className="summary-grid">
        {summaryData.map((item, index) => (
          <div key={index} className={`summary-card ${item.color}-light`}>
            <div className="card-content">
              <div className="card-left">
                <span className="card-icon-wrapper">
                  <Iconography
                    icon={item.icon as any}
                    size={IconographySizes.Small}
                  />
                </span>
                <span className="card-label">{item.label}</span>
              </div>
              {isEditable ? (
                <input
                  type="text"
                  className="card-input"
                  value={item.value}
                  onChange={(e) => handleInputChange(item.field, e.target.value)}
                />
              ) : (
                <span className="card-value">{item.value}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummarySection;
